import { Grid, SelectChangeEvent } from '@mui/material';

import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';

import {
	getExportData,
	getExportColNames,
	getFilterHeaderValues,
	getFiltersValues,
} from 'common/api';
import {
	IAllFilterType,
	IExportDataPayload,
	IFilterKeysParams,
	IFilterKeysResponse,
} from 'common/api/type-def';
import ExportData from 'common/components/ExportData/ExportData';
import AdvancedFilters from 'common/components/Filters/AdvancedFilters';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import {
	DOWNLOAD_FAILED_ERROR_LABEL,
	EXPORT_EXCEL_NAME_DATE_FORMAT,
	EXPORT_FILE_TYPE,
	MODULES,
	ViewType,
} from 'common/constants';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import {
	ENTITY_TYPE,
	HEAT_MAP_PARAM_KEY,
	POLICY_TABLE_EXPORT_COLUMN_OPTIONS,
	POLICY_TABLE_EXPORT_HEADER_MAPPING,
	PRC_LANDING_ENTITY_COUNT_DEFAULT,
	PRC_TABLE_KEYS,
	PRC_TABLE_TYPE,
	TAXONOMY_CURRENT_TAB_LIST,
} from 'common/constants/TaxonomyConstants';
import { APP_GENERAL_ERROR_MSG } from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import {
	setRiskRefApplyFilterEnabled,
	setRiskRefApplyTaxonomyFilterFlag,
	setRiskRefSearchText,
	setRiskRefTaxonomyFilter,
	setRiskRefTaxonomySourceFilters,
	setRiskRefTaxonomySourceFiltersKey,
	setRiskRefTaxonomySourceFiltersKeyFlag,
	setTaxonomyAppliedFilterList,
	setTaxonomyDrawerState,
	setTaxonomyFilterKeys,
	setTaxonomySelectedAppliedFilterList,
} from 'common/store/reducer/taxonomyReducer';
import {
	capitalizeName,
	downloadCsvFileData,
	getAdvanceFilterPayloadData,
	toSentenceCase,
} from 'common/utils/utilFunctions';

import { handleSpecialCharacters } from '../TaxonomyUtils';

import { getDataBaseOptionsList, getSearchRiskReferenceValues } from './api';
import {
	IApplyFilterParam,
	IDataBaseOptionsResponse,
	IExportColumnNames,
	TaxonomySearchCount,
} from './api/type-def';
import PRCInventoryLandingHeader from './Components/PRCInventoryLandingHeader/PRCInventoryLandingHeader';
import {
	EXPORT_HEAT_MAP_COLUMNS_LIST,
	EXPORT_TAB_LIST,
	EXPORT_NAME,
} from './ExportColOptionConfig';
import { countTabTaxonomyMapping } from './RiskRefTaxonomyTabs/RiskRefTaxonomyUtils';
import RiskTaxonomyHeatMap from './RiskRefTaxonomyTabs/RisksTaxonomyHeatMap/RiskTaxonomyHeatMap';
import RisksTaxonomyTable from './RiskRefTaxonomyTabs/RisksTaxonomyTable/RisksTaxonomyTable';
import {
	filterArrayHandler,
	generateExportPayloadForRiskReferenceTaxonomy,
	generatePayloadForHeatMapExport,
	getExportColOptions,
	getExportedCount,
} from './RiskRefTaxonomyUtils';

import taxonomyStyles from './RiskRefTaxonomy.module.scss';

type FilterKey = {
	key: string;
	values: string[];
};
export type FilterParam = {
	filter: FilterKey[];
};

const { OBLIGATION, PROCESS, RISK, CONTROL, POLICY } = ENTITY_TYPE;
const { HEATMAP } = ViewType;
const { OK } = HTTP_STATUS_CODES;
const { TABLE_COLUMN, HEATMAP_COLUMN } = EXPORT_NAME;
const { RISK_REFERENCE_TAXONOMY } = MODULES;
const { EXCEL } = EXPORT_FILE_TYPE;
const { REACT_APP_ENVIRONMENT } = process.env;

const RiskRefTaxonomy: React.FC = () => {
	const dispatch = useDispatch();

	const tabName = useSelector(
		(state: RootState) => state.common.selectedTabName,
	);
	const tabIndex = useSelector(
		(state: RootState) => state.common.selectedTabIndex,
	);
	const refSearchText = useSelector(
		(state: RootState) => state.taxonomy.riskRefSearchText,
	);
	const refFilterData = useSelector(
		(state: RootState) => state.taxonomy.riskRefTaxonomyFilters,
	);
	const applyFilterEnabled = useSelector(
		(state: RootState) => state.taxonomy.applyFilterEnabled,
	);
	const taxonomyDrawerState = useSelector(
		(state: RootState) => state.taxonomy.taxonomyDrawerState,
	);
	const taxonomyAppliedfilterKeys = useSelector(
		(state: RootState) => state.taxonomy.taxonomyAppliedfilterKeys,
	);
	const taxonomySelectedAppliedfilterKeys = useSelector(
		(state: RootState) => state.taxonomy.taxonomySelectedAppliedfilterKeys,
	);
	const riskRefTaxonomySourceFiltersKey = useSelector(
		(state: RootState) => state.taxonomy.riskRefTaxonomySourceFiltersKey,
	);
	const taxonomyViewType = useSelector(
		(state: RootState) => state.taxonomy.taxonomyViewTypeValue,
	);

	const [dataBaseOptionsList, setDataBaseOptionsList] = useState<
		IDataBaseOptionsResponse[]
	>([]);
	const [taxonomySearchCount, setTaxonomySearchCount] =
		useState<TaxonomySearchCount>(PRC_LANDING_ENTITY_COUNT_DEFAULT);
	const [isExportApiLoading, setIsExportApiLoading] = useState<boolean>(false);
	const [selectedUpdatedFilterData, setUpdatedFilterData] =
		useState<FilterParam[]>(refFilterData);
	const [isApiLoading, setApiLoading] = useState<any>({
		count: true,
		filters: false,
	});
	const [toastMessage, setToastMessageLocal] = useState('');
	const [isToastOpen, setIsToastOpen] = useState(false);
	const [openExportModal, setOpenExportModal] = useState<boolean>(false);
	const [isClearAllSelected, setIsClearAllSelected] = useState(false);
	const [colNamesMapping, setColNamesMapping] = useState<IExportColumnNames>();

	const onAdvanceFilter = async () => {
		setIsToastOpen(false);
		setApiLoading((previous: any) => ({ ...previous, filters: true }));
		const selectedTabName = getTabFilterKey(tabIndex);
		// call api to get the filter values and call the relationship api
		const typeViewPayload = taxonomyViewType === HEATMAP ? 'heatmapView' : '';

		const paramsObj: IFilterKeysParams = {
			module: selectedTabName,
			dataSource: riskRefTaxonomySourceFiltersKey,
			viewType: tabIndex !== 4 ? typeViewPayload : '',
		};

		const res: any = await getFilterHeaderValues(paramsObj);
		if (res?.statusCode === OK && res?.responseBody) {
			dispatch(setTaxonomyFilterKeys(res?.responseBody));
			getAllFilteredDropdownData(res?.responseBody);
		} else {
			setIsToastOpen(true);
			setToastMessageLocal(APP_GENERAL_ERROR_MSG);
			setApiLoading((previous: any) => ({ ...previous, filters: false }));
		}
	};

	const getAllFilterKeys = (data: IFilterKeysResponse[]) => {
		const filterKeys = data.map(
			(value: IFilterKeysResponse) => value?.filterKey,
		);
		const updatedFilteredKeys = filterKeys.filter(
			(element) => element !== null,
		);
		return updatedFilteredKeys;
	};
	const onCloseAdvancedFilter = () => {
		dispatch(setTaxonomyDrawerState(!taxonomyDrawerState));
	};

	const onCancelAdvancedFilter = () => {
		if (!applyFilterEnabled) {
			dispatch(setRiskRefTaxonomyFilter([]));
			setUpdatedFilterData([]);
			dispatch(setRiskRefApplyFilterEnabled(false));
			dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
		}
		dispatch(setTaxonomyDrawerState(!taxonomyDrawerState));
	};

	const handleClearFilter = () => {
		dispatch(setRiskRefTaxonomyFilter([]));
		dispatch(setTaxonomySelectedAppliedFilterList([]));
		setUpdatedFilterData([]);
		setIsClearAllSelected(true);
		if (applyFilterEnabled) {
			dispatch(setRiskRefApplyFilterEnabled(false));
			dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
		}
	};

	const getTabFilterKey = (indexType: number) => {
		let tableIndex = '';
		switch (indexType) {
			case 0:
				tableIndex = PROCESS;
				break;
			case 1:
				tableIndex = RISK;
				break;
			case 2:
				tableIndex = CONTROL;
				break;
			case 3:
				tableIndex = OBLIGATION;
				break;
			case 4:
				tableIndex = POLICY;
				break;
			default:
				break;
		}
		return tableIndex;
	};

	const generateColNamesMapping = async () => {
		setIsExportApiLoading(true);
		const res = await getExportColNames(
			taxonomyViewType === HEATMAP ? HEATMAP_COLUMN : TABLE_COLUMN,
		);
		if (res?.statusCode === OK && res?.responseBody) {
			setIsExportApiLoading(false);
			setColNamesMapping(res.responseBody);
			if (taxonomyViewType !== HEATMAP) {
				setOpenExportModal(true);
			} else {
				setOpenExportModal(false);
				exportHandlerForHeatMap(res.responseBody);
			}
		} else {
			setIsToastOpen(true);
			setToastMessageLocal(
				res?.errorBody?.errorMessage || APP_GENERAL_ERROR_MSG,
			);
		}
	};

	const exportHandlerForHeatMap = async (colNamesMapping: any) => {
		const payloadRes: IExportDataPayload = generatePayloadForHeatMapExport(
			riskRefTaxonomySourceFiltersKey,
			tabIndex,
			REACT_APP_ENVIRONMENT,
			refSearchText,
			refFilterData,
			taxonomySearchCount,
		);
		const getTabName: string = EXPORT_TAB_LIST[tabIndex];
		const sortedColNames: any = EXPORT_HEAT_MAP_COLUMNS_LIST[getTabName].map(
			(key: string) => colNamesMapping[key],
		);
		const res: any = await getExportData(payloadRes, RISK_REFERENCE_TAXONOMY);
		if (res?.statusCode === OK && res?.responseBody) {
			downloadCsvFileData(
				res?.responseBody.content,
				`${capitalizeName(EXPORT_TAB_LIST[tabIndex] || '')}_heatmap_${moment(
					new Date(),
				).format(EXPORT_EXCEL_NAME_DATE_FORMAT)}`,
				EXCEL,
				colNamesMapping ? sortedColNames : undefined,
				EXPORT_HEAT_MAP_COLUMNS_LIST[getTabName],
			);
		} else {
			dispatch(
				setToastMessage({
					message: res?.errorBody?.errorMessage || DOWNLOAD_FAILED_ERROR_LABEL,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
	};

	const getAllFilteredDropdownData = async (data: any) => {
		const filtersData = data;
		const allKeys = getAllFilterKeys(filtersData);
		const updatedSearchString = handleSpecialCharacters(refSearchText);
		const paramsObj: IAllFilterType = {
			searchText: updatedSearchString,
			index: tabName,
			filter: refFilterData,
			relationship: allKeys,
			source: riskRefTaxonomySourceFiltersKey,
		};
		const res: any = await getFiltersValues(paramsObj, RISK_REFERENCE_TAXONOMY);
		if (res?.statusCode === OK) {
			const allFilteredData: any = res?.responseBody?.relationship;
			const allRelations = allFilteredData;

			getAdvanceFilterPayloadData(allRelations, filtersData);

			dispatch(setTaxonomyAppliedFilterList(allRelations));

			setApiLoading((previous: any) => ({ ...previous, filters: false }));
			dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
			dispatch(setTaxonomyDrawerState(!taxonomyDrawerState));
		} else {
			setApiLoading((previous: any) => ({ ...previous, filters: false }));
			dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
			setIsToastOpen(true);
			setToastMessageLocal(APP_GENERAL_ERROR_MSG);
			setUpdatedFilterData([]);
		}
	};

	const handleResetFilter = () => {
		setUpdatedFilterData([]);
		setIsClearAllSelected(false);
	};

	const applyFiltersHandlerData = (data: any) => {
		dispatch(setTaxonomySelectedAppliedFilterList(data));
		const resultArr: any = [];

		filterArrayHandler(data, resultArr);

		dispatch(setRiskRefTaxonomyFilter(resultArr));
		setUpdatedFilterData(resultArr);
		dispatch(setRiskRefApplyFilterEnabled(true));
		dispatch(setRiskRefApplyTaxonomyFilterFlag(true));
		dispatch(setTaxonomyDrawerState(false));
	};

	const setCountsUpdatedObject = (events: any) => {
		let resultObject: TaxonomySearchCount = PRC_LANDING_ENTITY_COUNT_DEFAULT;

		if (events && events.length > 0) {
			events.forEach((ele: any) => {
				resultObject = countTabTaxonomyMapping(
					ele.objectType,
					ele,
					resultObject,
				);
			});
		}
		return resultObject;
	};
	const getAllRefCountsData = async (filterData: any, key?: string) => {
		if (riskRefTaxonomySourceFiltersKey !== '') {
			setApiLoading((previous: any) => ({ ...previous, count: true }));
			const updatedSearchString = handleSpecialCharacters(refSearchText);
			const viewTypeObj = { viewType: HEAT_MAP_PARAM_KEY };
			const heatMapParamObj = taxonomyViewType === HEATMAP ? viewTypeObj : '';
			const paramsObj = {
				searchText: updatedSearchString,
				index: tabName,
				filter: filterData,
				source: key,
				...heatMapParamObj,
			};
			const res: any = await getSearchRiskReferenceValues(paramsObj);
			if (res?.responseBody) {
				const events: any = res?.responseBody;
				const allCountsData: TaxonomySearchCount = setCountsUpdatedObject(
					events?.objectCounts || [],
				);
				setTaxonomySearchCount(allCountsData);
				setApiLoading((previous: any) => ({ ...previous, count: false }));
				dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
			} else {
				setApiLoading((previous: any) => ({ ...previous, count: false }));
				dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
				setTaxonomySearchCount(PRC_LANDING_ENTITY_COUNT_DEFAULT);
			}
			setIsClearAllSelected(false);
		}
	};

	const handleToast = useCallback(() => {
		setIsToastOpen(false);
		setToastMessageLocal('');
	}, []);

	const handleDataBaseSelectChange = (event: SelectChangeEvent<string>) => {
		const sourceValue = event.target.value;
		const datasourceObj: IApplyFilterParam = {
			key: 'source',
			values: [sourceValue],
		};
		handleResetFilter();
		dispatch(setRiskRefSearchText(''));
		dispatch(setRiskRefTaxonomyFilter([]));
		dispatch(setRiskRefApplyTaxonomyFilterFlag(false));
		dispatch(setTaxonomySelectedAppliedFilterList([]));
		dispatch(setRiskRefApplyFilterEnabled(false));
		dispatch(setRiskRefTaxonomySourceFilters([datasourceObj]));
		dispatch(setRiskRefTaxonomySourceFiltersKeyFlag(true));
		dispatch(setRiskRefTaxonomySourceFiltersKey(event.target.value));
	};

	const exportHandler = async () => {
		const selectedTabName = getTabFilterKey(tabIndex);
		const exportTypeName = TAXONOMY_CURRENT_TAB_LIST[tabIndex];
		// policy will directly export excel
		if (selectedTabName === POLICY) {
			setIsExportApiLoading(true);
			setOpenExportModal(true);
			const { payload, selectedColKeys } =
				generateExportPayloadForRiskReferenceTaxonomy(
					POLICY_TABLE_EXPORT_COLUMN_OPTIONS,
					riskRefTaxonomySourceFiltersKey,
					exportTypeName,
					refSearchText,
					refFilterData,
					getExportedCount(exportTypeName, taxonomySearchCount),
				);
			const res: any = await getExportData(payload, RISK_REFERENCE_TAXONOMY);
			if (res?.statusCode === OK && res?.responseBody) {
				downloadCsvFileData(
					res?.responseBody.content,
					`${capitalizeName(exportTypeName || '')}_${moment(new Date()).format(
						EXPORT_EXCEL_NAME_DATE_FORMAT,
					)}`,
					EXCEL,
					Object.values(POLICY_TABLE_EXPORT_HEADER_MAPPING).map(
						(name: string) => toSentenceCase(name),
					),
					selectedColKeys,
				);
			} else {
				dispatch(
					setToastMessage({
						message:
							res?.errorBody?.errorMessage || DOWNLOAD_FAILED_ERROR_LABEL,
						severity: 'error',
						isToastOpen: true,
					}),
				);
			}
			setIsExportApiLoading(false);
			setOpenExportModal(false);
		} else {
			generateColNamesMapping();
		}
	};

	const closeEditModal = () => {
		setOpenExportModal(false);
	};

	const getDataBaseOptions = async () => {
		try {
			const res = await getDataBaseOptionsList();
			if (res?.statusCode === OK && res?.responseBody) {
				const result: IDataBaseOptionsResponse[] = res?.responseBody;
				setDataBaseOptionsList(result);
				if (riskRefTaxonomySourceFiltersKey === '') {
					const datasourceObj: IApplyFilterParam = {
						key: 'source',
						values: [result[0].value],
					};
					dispatch(setRiskRefTaxonomySourceFilters([datasourceObj]));
					dispatch(setRiskRefTaxonomySourceFiltersKeyFlag(true));
					dispatch(setRiskRefTaxonomySourceFiltersKey(result[0].value));
				} else {
					const datasourceObj: IApplyFilterParam = {
						key: 'source',
						values: [riskRefTaxonomySourceFiltersKey],
					};
					dispatch(setRiskRefTaxonomySourceFilters([datasourceObj]));
					dispatch(setRiskRefTaxonomySourceFiltersKeyFlag(false));
					dispatch(
						setRiskRefTaxonomySourceFiltersKey(riskRefTaxonomySourceFiltersKey),
					);
				}
				setUpdatedFilterData(refFilterData);
				dispatch(setRiskRefTaxonomyFilter(refFilterData));
			} else {
				setDataBaseOptionsList([]);
				setIsToastOpen(true);
				setToastMessageLocal(APP_GENERAL_ERROR_MSG);
			}
		} catch (error) {
			setIsToastOpen(true);
			setToastMessageLocal(APP_GENERAL_ERROR_MSG);
		}
	};

	useEffect(() => {
		getDataBaseOptions();
	}, []);
	useEffect(() => {
		getAllRefCountsData(
			selectedUpdatedFilterData,
			riskRefTaxonomySourceFiltersKey,
		);
	}, [refSearchText]);
	useEffect(() => {
		getAllRefCountsData(refFilterData, riskRefTaxonomySourceFiltersKey);
	}, [refFilterData]);
	useEffect(() => {
		getAllRefCountsData(
			selectedUpdatedFilterData,
			riskRefTaxonomySourceFiltersKey,
		);
	}, [riskRefTaxonomySourceFiltersKey]);

	return (
		<>
			<PRCInventoryLandingHeader
				dataBaseOptionsList={dataBaseOptionsList}
				isApiLoading={isApiLoading}
				PRCEntityCount={taxonomySearchCount}
				handleDataBaseSelectChange={handleDataBaseSelectChange}
				exportHandler={exportHandler}
				onAdvanceFilter={onAdvanceFilter}
				handleResetFilter={handleResetFilter}
			/>
			<Grid container data-testid="risk-ref-testId">
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						{taxonomyViewType === HEATMAP ? (
							<RiskTaxonomyHeatMap
								isClearFilterValues={isClearAllSelected}
								selectedTabIndex={tabIndex}
							/>
						) : (
							<RisksTaxonomyTable
								isClearFilterValues={isClearAllSelected}
								tableType={PRC_TABLE_TYPE[tabIndex]}
								key={PRC_TABLE_KEYS[tabIndex]}
								selectedTabIndex={tabIndex}
							/>
						)}
					</Grid>
				</Grid>
				{taxonomyDrawerState && (
					<SideDrawer
						className={taxonomyStyles['risk-ref-advancefilter-drawer']}
						drawerState={taxonomyDrawerState}
						customClass={taxonomyStyles['custom-width']}
					>
						<AdvancedFilters
							applyFiltersHandler={applyFiltersHandlerData}
							handleClearFilter={handleClearFilter}
							onClose={onCloseAdvancedFilter}
							filterOptionsData={taxonomyAppliedfilterKeys}
							filterDataLoading={isApiLoading.filters}
							selectedListOptions={taxonomySelectedAppliedfilterKeys}
							onCancel={onCancelAdvancedFilter}
							moduleType={false}
						/>
					</SideDrawer>
				)}
				{(openExportModal || isExportApiLoading) &&
					taxonomyViewType !== HEATMAP && (
						<ExportData
							optionsData={getExportColOptions(
								TAXONOMY_CURRENT_TAB_LIST[tabIndex],
							)}
							exportTypeName={TAXONOMY_CURRENT_TAB_LIST[tabIndex]}
							exportedCount={getExportedCount(
								TAXONOMY_CURRENT_TAB_LIST[tabIndex],
								taxonomySearchCount,
							)}
							refFilterData={refFilterData}
							refSearchText={refSearchText}
							source={riskRefTaxonomySourceFiltersKey}
							colNamesMapping={colNamesMapping}
							onCloseModal={closeEditModal}
							isDataLoading={isExportApiLoading}
							moduleType={RISK_REFERENCE_TAXONOMY}
						/>
					)}
				<AlertComponent
					open={isToastOpen}
					toastMessage={toastMessage}
					severity="error"
					handleCloseMessage={handleToast}
					vertical="top"
					horizontal="right"
				/>
			</Grid>
		</>
	);
};

export default RiskRefTaxonomy;
